// extracted by mini-css-extract-plugin
export var deliveryRow = "_nl-a";
export var fixedHeight = "_nl-4";
export var freightLogo = "_nl-9";
export var fullWidth = "_nl-3";
export var priceColumn = "_nl-5";
export var radioSelected = "_nl-7";
export var radioUnselected = "_nl-6";
export var selectedOption = "_nl-2";
export var selectedOptionContainer = "_nl-1";
export var selection = "_nl-0";
export var tallSkeletonText = "_nl-8";